import { PROJECT_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

export const getAllWorkReports = async (filters, pageSize, pageNo) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/work-report?${
        filters.employeeId ? 'employeeId=' + filters.employeeId + '&' : ''
      }${filters.projectId ? 'projectId=' + filters.projectId + '&' : ''}${
        filters.year ? 'year=' + filters.year + '&' : ''
      }${filters.quarter ? 'quarter=' + filters.quarter + '&' : ''}${filters.status ? 'status=' + filters.status + '&' : ''}${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNo >= 0 ? 'pageNumber=' + pageNo : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeeWorkReports = async (
  employeeId,
  filters,
  pageSize,
  pageNo,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/work-report/employeeId/${employeeId}?${filters.projectId ? 'projectId=' + filters.projectId + '&' : ''}${
        filters.year ? 'year=' + filters.year + '&' : ''
      }${filters.quarter ? 'quarter=' + filters.quarter + '&' : ''}${filters.status ? 'status=' + filters.status + '&' : ''}${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNo >= 0 ? 'pageNumber=' + pageNo : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getManageEmployeeWorkReports = async (
  managerId,
  filters,
  pageSize,
  pageNo,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/work-report/manager/${managerId}?${
        filters.employeeId ? 'employeeId=' + filters.employeeId + '&' : ''
      }${filters.projectId ? 'projectId=' + filters.projectId + '&' : ''}${
        filters.year ? 'year=' + filters.year + '&' : ''
      }${filters.quarter ? 'quarter=' + filters.quarter + '&' : ''}${filters.status ? 'status=' + filters.status + '&' : ''}${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNo >= 0 ? 'pageNumber=' + pageNo : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const updateWorkReport = async (payload) => {
  try {
    const response = await _axios.put(`${PROJECT_PATH}/work-report`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
